import { FormBuilder } from '@angular/forms';
import { BudgetDistributionType } from '../constants/BudgetDistributionType.const';
import { PlannerDTOField } from '../interfaces/PlannerDTOField';
import { PlannerBaseDTO } from './PlannerBaseDTO';

export class BudgetDistributionDTO extends PlannerBaseDTO {
    fields: PlannerDTOField[] = [
        {
            name: 'distributionType',
            type: 'string',
            defaultValue: BudgetDistributionType.value.key
        },
        {
            name: 'budgetDistribution',
            type: 'Array<any>',
            defaultValue: [],
            createInitialItem: true
        }
    ];

    constructor(fb: FormBuilder) {
        super(fb);
        this.init();
    }
}